var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessageFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.75736 11.7574C6 13.5147 6 16.3431 6 22V26C6 31.6569 6 34.4853 7.75736 36.2426C9.51472 38 12.3431 38 18 38H30C35.6569 38 38.4853 38 40.2426 36.2426C42 34.4853 42 31.6569 42 26V22C42 16.3431 42 13.5147 40.2426 11.7574C38.4853 10 35.6569 10 30 10H18C12.3431 10 9.51472 10 7.75736 11.7574ZM13.1094 16.3359C12.1903 15.7232 10.9486 15.9715 10.3359 16.8906C9.72319 17.8097 9.97154 19.0514 10.8906 19.6641L21.7812 26.9245C23.1248 27.8202 24.8752 27.8202 26.2188 26.9245L37.1094 19.6641C38.0285 19.0514 38.2768 17.8097 37.6641 16.8906C37.0514 15.9715 35.8097 15.7232 34.8906 16.3359L24 23.5963L13.1094 16.3359Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageFill);
export default __webpack_public_path__ + "static/media/Message_fill.bfedfca922ac4456bbae05f511bfee3a.svg";
export { ForwardRef as ReactComponent };